import React from "react";
import styles from "../../../../assets/styles/components/Suggestion.module.scss";

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------
type PlatformType = "GOOGLE" | "META" | "YAHOO";

export type CrossPlatformBudget = {
    campaign_id: string;
    campaign_name: string;
    platform: PlatformType;
    before_budget: string;
    suggested_budget: string;
    current_pacing: string;
    target_pacing: string;
    reason?: string;
};

type Props = {
    budgets: CrossPlatformBudget[];
    formData: Record<string, string>;
    onChange: (id: string, val: string) => void;
    unit?: string;
};

// -----------------------------------------------------------------------------
// Component: CrossPlatformBudgetForm
// -----------------------------------------------------------------------------
const CrossPlatformBudgetForm: React.FC<Props> = ({ budgets, formData, onChange, unit }) => {
    return (
        <div className={styles.budgetFormContainer}>
            {budgets.map((cp) => (
                <section key={cp.campaign_id} className={styles.campaignCard}>
                    <div className={styles.campaignName}>
                        {cp.campaign_name}
                    </div>

                    {cp.reason && (
                        <div className={styles.reasonBar}>
                            <strong>Aibex提案理由:</strong> {cp.reason}
                        </div>
                    )}

                    <div className={styles.suggestionBox}>
                        {/* Before */}
                        <div className={styles.beforePanel}>
                            <div className={styles.panelTitle}>現在の日予算</div>
                            <div className={styles.mainValue}>
                                {Number(cp.before_budget).toLocaleString()}
                                <span>{unit}</span>
                            </div>
                            <div className={styles.subValue}>
                                着地見込み:<span>{cp.current_pacing}%</span>
                            </div>
                        </div>

                        {/* Arrow */}
                        <div className={styles.arrowIcon}>→</div>

                        {/* After */}
                        <div className={styles.afterPanel}>
                            <div className={styles.panelTitle}>AI提案</div>
                            <div className={styles.inputWrap}>
                                <input
                                    type="text"
                                    value={
                                        formData[cp.campaign_id]
                                            ? Number(String(formData[cp.campaign_id]).replace(/,/g, "")).toLocaleString()
                                            : ""
                                    }
                                    onChange={(e) => {
                                        const rawValue = e.target.value.replace(/,/g, "");
                                        // Allow empty or numeric input
                                        if (rawValue === "" || !isNaN(Number(rawValue))) {
                                            onChange(cp.campaign_id, rawValue);
                                        }
                                    }}
                                    placeholder="0"
                                />
                                <span>{unit}</span>
                            </div>
                            <div className={styles.subValue}>
                                改善後予想:
                                <span>{cp.target_pacing}%</span>
                            </div>

                            {/* Alerts for budget constraints */}
                            {formData[cp.campaign_id] && Number(formData[cp.campaign_id]) > 0 && (
                                <>
                                    {/* Absolute Minimum Warning */}
                                    {Number(formData[cp.campaign_id]) < 1000 && (
                                        <div className={styles.alertMessage}>
                                            ※日予算が少なすぎると、コンバージョンデータが十分に蓄積されず、自動入札の機械学習が正常に機能しない可能性があります。目標CPAの5〜10倍程度の予算設定を推奨します。
                                        </div>
                                    )}
                                    {/* Relative 20% Change Warning */}
                                    {Number(formData[cp.campaign_id]) >= 1000 && (Number(formData[cp.campaign_id]) < Number(cp.before_budget) * 0.8 || Number(formData[cp.campaign_id]) > Number(cp.before_budget) * 1.2) && (
                                        <div className={styles.alertMessage}>
                                            ※日予算を一度に20%以上変更すると、媒体の機械学習がリセットされ一時的にパフォーマンスが不安定になる可能性があります。段階的な変更を推奨します。
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </section>
            ))}
        </div>
    );
};

export default CrossPlatformBudgetForm;
